import { Button } from '@cian/ui-kit';
import { Chat16 } from '@cian/ui-kit/icons';
import { Header2, Header4, Paragraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

interface ICalltrackingWarningProps {
  isChatEnabled: boolean;
  phones: string[];
  openChat?(): void;
}

export const CalltrackingWarning: React.FC<ICalltrackingWarningProps> = ({ isChatEnabled, phones, openChat }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['message-block']}>
        <div className={styles['header']}>
          <Header4>Это временные телефоны</Header4>
        </div>
        <div className={styles['message']}>
          <Paragraph1 color="gray60_100">
            {isChatEnabled
              ? 'Настоящие номера защищены от спама, поэтому смс не дойдут; написать автору объявления получится только в чате'
              : 'Настоящий защищён от спама. Если автор объявления заметит пропущенный, он перезвонит с другого номера.'}
          </Paragraph1>
        </div>
        {isChatEnabled && (
          <Button beforeIcon={<Chat16 color="white_100" />} size="XS" onClick={openChat}>
            Написать в чат
          </Button>
        )}
      </div>
      <div className={styles['phones-block']}>
        {phones.map((phone, index) => {
          return (
            <a key={index} href={`tel:${phone}`} className={styles['phone']}>
              <Header2>{phone}</Header2>
            </a>
          );
        })}
      </div>
    </div>
  );
};
